<div class="flex h-full flex-col bg-gray-50">
  <!-- Header -->
  <div class="bg-white px-6 py-4 border-b border-gray-200 flex items-center justify-between">
    <div>
      <h2 class="text-xl font-semibold text-gray-900">
        {{ taskData ? 'Edit Vendor Work' : 'New Vendor Work' }}
      </h2>
      <p class="mt-1 text-sm text-gray-500">
        {{ selectedVendorCategory ? selectedVendorCategory + ' Services' : 'Select a service category' }}
      </p>
    </div>
    <button 
      class="rounded-full p-2 hover:bg-gray-100 text-gray-500"
      (click)="toggleVendorSlideOut()">
      <span class="sr-only">Close panel</span>
      <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <!-- Main Content -->
  <div class="flex-1 overflow-y-auto">
    <form [formGroup]="vendorWorkForm" class="max-w-4xl mx-auto py-6 px-4 sm:px-6">
      <!-- Progress Steps -->
      <div class="mb-8">
        <ol class="flex items-center">
          <li class="flex items-center" [class.text-blue-600]="!selectedVendorCategory" [class.text-green-600]="selectedVendorCategory">
            <span class="flex items-center justify-center w-8 h-8 border-2 rounded-full shrink-0"
                  [class.border-blue-600]="!selectedVendorCategory"
                  [class.border-green-600]="selectedVendorCategory">
              <svg *ngIf="selectedVendorCategory" class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
              </svg>
              <span *ngIf="!selectedVendorCategory">1</span>
            </span>
            <span class="ml-2 text-sm font-medium">Category</span>
          </li>
          <li class="flex-auto mx-4">
            <div class="h-0.5 bg-gray-200"></div>
          </li>
          <li class="flex items-center" [class.text-blue-600]="selectedVendorCategory && !selectedVendors.length" [class.text-gray-500]="!selectedVendorCategory" [class.text-green-600]="selectedVendors.length > 0">
            <span class="flex items-center justify-center w-8 h-8 border-2 rounded-full shrink-0"
                  [class.border-blue-600]="selectedVendorCategory && !selectedVendors.length"
                  [class.border-gray-500]="!selectedVendorCategory"
                  [class.border-green-600]="selectedVendors.length > 0">
              <svg *ngIf="selectedVendors.length > 0" class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
              </svg>
              <span *ngIf="!selectedVendors.length">2</span>
            </span>
            <span class="ml-2 text-sm font-medium">Vendors</span>
          </li>
          <li class="flex-auto mx-4">
            <div class="h-0.5 bg-gray-200"></div>
          </li>
          <li class="flex items-center" [class.text-blue-600]="selectedVendors.length > 0 && vendorWorkForm.valid" [class.text-gray-500]="selectedVendors.length === 0">
            <span class="flex items-center justify-center w-8 h-8 border-2 rounded-full shrink-0"
                  [class.border-blue-600]="selectedVendors.length > 0 && vendorWorkForm.valid"
                  [class.border-gray-500]="selectedVendors.length === 0">
              3
            </span>
            <span class="ml-2 text-sm font-medium">Details</span>
          </li>
        </ol>
      </div>

     <!-- Category Selection -->
      <div class="bg-white rounded-lg shadow p-6 mb-6">
        <label class="block text-sm font-medium text-gray-700 mb-2">Service Category</label>
        <select
          [(ngModel)]="selectedVendorCategory"
          (ngModelChange)="onVendorCategoryChange($event)"
          [ngModelOptions]="{standalone: true}"
          [disabled]="!!subletSelected"
          class="w-full border-gray-300 rounded-lg shadow-sm focus:border-blue-500 focus:ring-blue-500 disabled:bg-gray-50 disabled:text-gray-500">
          <option value="">Select a category</option>
          <option *ngFor="let category of vendorCategories" 
                  [value]="category.value"
                  [selected]="category.value === selectedVendorCategory">
            {{category.label}}
          </option>
        </select>
        <p *ngIf="subletSelected" class="mt-2 text-sm text-gray-500">
          Category is pre-selected based on the sublet type
        </p>
      </div>

      <!-- Vendor Search -->
      <div class="bg-white rounded-lg shadow p-6 mb-6">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-medium text-gray-900">Select Vendors</h3>
          <div class="text-sm text-gray-500">
            {{ selectedVendors.length }} vendor{{ selectedVendors.length === 1 ? '' : 's' }}
          </div>
        </div>

        <!-- Search Input -->
        <div class="relative mb-6">
          <input
            type="text"
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchInput($event)"
            [ngModelOptions]="{standalone: true}"
            placeholder="Search vendors by name, phone, or location..."
            class="w-full border-gray-300 rounded-lg shadow-sm focus:border-blue-500 focus:ring-blue-500 pl-10"
            [disabled]="!selectedVendorCategory"
          />
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
        </div>

        <!-- Unified Vendor List -->
        <div class="border rounded-lg overflow-hidden">
          <div class="max-h-[480px] overflow-y-auto">
            <div *ngFor="let vendor of getFilteredVendors(); trackBy: trackByVendor"
                 class="group flex items-center p-3 hover:bg-gray-50 border-b last:border-b-0 cursor-pointer"
                 [class.bg-blue-50]="isVendorSelected(vendor)"
                 (click)="toggleVendorSelection(vendor)">
              <!-- Selection Checkbox -->
              <div class="flex-shrink-0 mr-4">
                <div class="w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors"
                     [class.border-blue-600]="isVendorSelected(vendor)"
                     [class.border-gray-300]="!isVendorSelected(vendor)"
                     [class.bg-blue-600]="isVendorSelected(vendor)">
                  <svg *ngIf="isVendorSelected(vendor)" class="w-4 h-4 text-white" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                  </svg>
                </div>
              </div>
              
              <!-- Vendor Info -->
              <div class="min-w-0 flex-1">
                <div class="flex items-center justify-between">
                  <div>
                    <div class="font-medium text-gray-900">{{ vendor.name }}</div>
                    <div class="text-sm text-gray-500">{{ vendor.phoneNumber }}</div>
                    <div class="text-sm text-gray-500" *ngIf="vendor.address">
                      {{ vendor.address.city }}, {{ vendor.address.state }}
                    </div>
                  </div>
                  <div class="ml-4 flex-shrink-0">
                    <span *ngIf="isVendorSelected(vendor)" 
                          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      Selected
                    </span>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- No Results Message -->
            <div *ngIf="searchQuery && getFilteredVendors().length === 0" 
                 class="text-center py-8 text-gray-500">
              No vendors found matching your search
            </div>

            <!-- Empty State -->
            <div *ngIf="!searchQuery && getFilteredVendors().length === 0" 
                 class="text-center py-8 text-gray-500">
              No vendors available for this category
            </div>
          </div>
        </div>

        <!-- Selected Vendors Summary -->
        <div *ngIf="selectedVendors.length > 0" class="mt-4 text-sm text-gray-600">
          <span class="font-medium">Selected:</span> 
          <span class="text-gray-700">{{ getSelectedVendorNames() }}</span>
        </div>
      </div>

      <!-- Task Details -->
      <div class="bg-white rounded-lg shadow p-6 mb-6">
        <div class="space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Request Details</label>
            <textarea
              formControlName="requestDetails"
              rows="4"
              class="w-full border-gray-300 rounded-lg shadow-sm focus:border-blue-500 focus:ring-blue-500"
              placeholder="Enter detailed requirements..."
            ></textarea>
            <div *ngIf="vendorWorkForm.get('requestDetails')?.touched && vendorWorkForm.get('requestDetails')?.invalid" 
                 class="mt-1 text-sm text-red-600">
              Request details are required
            </div>
          </div>
          
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">RO Number</label>
            <input
              formControlName="roNumber"
              type="text"
              class="w-full border-gray-300 rounded-lg shadow-sm focus:border-blue-500 focus:ring-blue-500"
              placeholder="Enter RO number (optional)"
            />
          </div>
        </div>
      </div>

    
     <!-- Image Upload Section -->
<div class="bg-white rounded-lg shadow p-4 sm:p-6">
  <label class="block text-sm font-medium text-gray-700 mb-4">Upload Images</label>
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
    <ng-container *ngFor="let upload of imageUploads; let i = index">
      <div class="relative aspect-[4/3] sm:aspect-square">
        <!-- Upload Area -->
        <label *ngIf="!upload.preview"
               class="h-full w-full border-2 border-dashed border-gray-300 rounded-lg p-3 sm:p-4 
                      hover:border-blue-500 transition-colors cursor-pointer 
                      flex flex-col items-center justify-center">
          <input
            #fileInput
            type="file"
            class="hidden"
            (change)="onImageUpload($event, i)"
            accept="image/*"
            capture="environment"
          />
          <div class="flex space-x-4 mb-2">
            <!-- Upload Icon -->
            <button type="button" 
                    (click)="triggerFileInput(i)" 
                    class="p-2 rounded-full bg-gray-50 hover:bg-gray-100 transition-colors">
              <svg class="w-6 h-6 sm:w-8 sm:h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </button>
            <!-- Camera Icon - Only shown on mobile devices with camera -->
            <button *ngIf="showCameraButton$ | async" 
                    type="button" 
                    (click)="captureImage(i)" 
                    class="p-2 rounded-full bg-gray-50 hover:bg-gray-100 transition-colors">
              <svg class="w-6 h-6 sm:w-8 sm:h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                      d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </button>
          </div>
          <span class="text-sm font-medium text-gray-900">Add Image</span>
          <p class="mt-1 text-xs text-gray-500 text-center">Upload or take photo</p>
          <p class="text-xs text-gray-400 hidden sm:block">PNG, JPG up to 10MB</p>
        </label>
        
        <!-- Preview Area -->
        <div *ngIf="upload.preview" 
             class="relative h-full w-full rounded-lg overflow-hidden group"
             (click)="openImageViewer(i)">
          <img [src]="upload.preview" 
               class="h-full w-full object-cover cursor-pointer" 
               alt="Preview" />
          <div class="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 
                      sm:transition-opacity sm:duration-200 
                      touch:opacity-100 sm:touch:opacity-0">
            <button
              type="button"
              (click)="removeImage($event, i)"
              class="absolute top-2 right-2 bg-white rounded-full p-2 shadow-lg hover:bg-red-50 transition-colors z-10">
              <svg class="w-4 h-4 sm:w-5 sm:h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
              <span class="sr-only">Remove image</span>
            </button>
            <div class="absolute bottom-2 left-2 right-2 z-10">
              <label
                class="w-full px-2 py-1.5 sm:px-3 sm:py-2 bg-white bg-opacity-90 rounded-md 
                       text-xs sm:text-sm font-medium text-gray-700 
                       hover:bg-opacity-100 transition-colors cursor-pointer text-center block">
                <input
                  type="file"
                  class="hidden"
                  (change)="onImageUpload($event, i)"
                  accept="image/*"
                />
                Replace Image
              </label>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  
  <p class="mt-3 text-xs text-gray-500 text-center">
    Upload up to 3 images to share with vendors
  </p>
</div>
    </form>
  </div>

  <!-- Footer Actions -->
  <div class="flex-shrink-0 border-t border-gray-200 p-4 bg-white">
  <div class="flex justify-end space-x-4">
    <button
      type="button"
      (click)="toggleVendorSlideOut()"
      [disabled]="isLoading"
      class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 disabled:opacity-50">
      Cancel
    </button>
    <button
    type="submit"
    (click)="sendToVendors()"
    [disabled]="isSubmitDisabled()"
    class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md shadow-sm hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed">
    <ng-container *ngIf="isLoading">
      <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline-block" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Updating...
    </ng-container>
    <ng-container *ngIf="!isLoading">
      {{ taskData ? 'Update Vendor Work' : 'Send to Vendors' }}
    </ng-container>
  </button>
  <button
    *ngIf="taskData && taskData.vendorCompleted"
    type="button"
    (click)="openCompleteConfirm()"
    [disabled]="isLoading || isCompletingRequest"
    class="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md shadow-sm hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed">
    <ng-container *ngIf="isCompletingRequest">
      <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline-block" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Completing...
    </ng-container>
    <ng-container *ngIf="!isCompletingRequest">
      Complete Request
    </ng-container>
  </button>
  </div>
</div>
</div>

<!-- Camera Preview Modal -->
<div *ngIf="showCameraPreview" 
class="fixed inset-0 z-50 bg-black flex flex-col">
<!-- Camera Header -->
<div class="p-4 flex justify-between items-center bg-black text-white">
<span class="text-lg">Take Photo</span>
<button (click)="closeCameraPreview()" class="p-2">
<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
</svg>
</button>
</div>

<!-- Camera Preview -->
<div class="flex-1 relative">
  <video #videoElement 
        [style.transform]="'scaleX(-1)'"
        class="absolute inset-0 w-full h-full object-cover">
  </video>
</div>

<!-- Camera Controls -->
<div class="p-4 flex justify-center items-center bg-black">
    <button (click)="takePhoto()" 
          class="w-16 h-16 rounded-full border-4 border-white flex items-center justify-center">
    <div class="w-12 h-12 rounded-full bg-white"></div>
    </button>
    </div>
</div>

<!-- Add this near the end of your template -->

<lib-confirmation-modal-tw
  [isOpen]="imageToDeleteIndex !== null"
  title="Delete Image"
  message="Are you sure you want to delete this image?"
  confirmButtonText="Delete"
  cancelButtonText="Cancel"
  type="reject"
  (confirm)="onConfirmDelete()"
  (cancel)="imageToDeleteIndex = null">
</lib-confirmation-modal-tw>

<lib-confirmation-modal-tw
  [isOpen]="isCompleteConfirmOpen"
  title="Complete Request"
  message="Are you sure you want to mark this request as complete? This action cannot be undone."
  confirmButtonText="Complete"
  cancelButtonText="Cancel"
  type="approve"
  (confirm)="onConfirmCompleteRequest()"
  (cancel)="onCancelCompleteRequest()">
</lib-confirmation-modal-tw>
